/* AZRIA — Cart drawer recommendations add-to-cart
   Hooks Dawn's <cart-drawer>.renderContents() to refresh the drawer UI
   after a successful AJAX add. Idempotent (won't double-bind). */

(function () {
  if (window.__azriaCartRecsInit) return;
  window.__azriaCartRecsInit = true;

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.azria-cart-recs__add-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('is-loading')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      var data = await response.json();

      if (data.status) {
        throw new Error(data.description || data.message || 'Unable to add');
      }

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else if (data.sections) {
        var drawerInner = document.querySelector('#CartDrawer');
        if (drawerInner && data.sections['cart-drawer']) {
          var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          var newInner = parsed.querySelector('#CartDrawer');
          if (newInner) drawerInner.innerHTML = newInner.innerHTML;
        }
        var bubble = document.getElementById('shopify-section-cart-icon-bubble');
        if (bubble && data.sections['cart-icon-bubble']) {
          var bp = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var newBubble = bp.querySelector('.shopify-section') || bp.body.firstElementChild;
          if (newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
      }

      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
    } catch (err) {
      console.error('[Azria cart recs] Add failed:', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      setTimeout(function () {
        btn.classList.remove('is-error');
        btn.disabled = false;
      }, 2000);
    }
  });
})();

/* Coupon chips — tap to pre-apply a discount code for checkout */
(function () {
  if (window.__azriaCouponsInit) return;
  window.__azriaCouponsInit = true;

  document.addEventListener('click', async function (e) {
    var chip = e.target.closest('.az-coupon-chip');
    if (!chip || chip.classList.contains('is-applied') || chip.classList.contains('is-loading')) return;

    e.preventDefault();
    e.stopPropagation();

    var code = chip.dataset.couponCode;
    if (!code) return;

    chip.classList.add('is-loading');
    try {
      await fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' });
      chip.classList.remove('is-loading');
      chip.classList.add('is-applied');
    } catch (err) {
      console.error('[Azria coupons] apply failed:', err);
      chip.classList.remove('is-loading');
    }
  });
})();

/* OPTIONAL: mark chips whose code is already applied (reads Shopify's
   discount_code cookie — undocumented internal; if Shopify changes it
   this silently stops and chips just show the default state. Safe to
   delete this whole block if you prefer zero such dependencies. */
(function () {
  function syncChips() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!m) return;
    var applied = decodeURIComponent(m[1]).toUpperCase();
    var chips = document.querySelectorAll('.az-coupon-chip');
    for (var i = 0; i < chips.length; i++) {
      if ((chips[i].dataset.couponCode || '').toUpperCase() === applied) {
        chips[i].classList.add('is-applied');
      }
    }
  }
  document.addEventListener('DOMContentLoaded', syncChips);
  syncChips();
})();